import { computeOneOffCosts } from './economics.js';
/**
 * Whether the project has anything to say about stages, TSAs or stranded cost.
 *
 * Three chapters of the deck are about the period between Day 1 and standing alone, and a project that
 * has not got there yet would export three empty ones. Exposed rather than inlined because the dialog
 * also needs it: a checkbox that is off by default AND explains why reads very differently from one
 * that is just off.
 */
export function hasStageData(state) {
    return (state.design.buildUps.length > 0 ||
        state.design.tsas.length > 0 ||
        Object.keys(state.design.strandedPlan).length > 0);
}
/** The dialog's opening position, and the server's defaults when a caller sends nothing. */
export function suggestedDeckOptions(state) {
    const staged = hasStageData(state);
    return {
        depth: 3,
        density: 'balanced',
        stages: staged,
        // Ignored downstream unless the project has a target design, but offering it on is misleading when
        // there is none — the chapter would simply not appear.
        target: state.targetEnabled,
        summary: true,
        bridge: staged,
        bridgeMetric: 'hc',
        stranded: staged,
        tsas: state.design.tsas.length > 0,
        oneoff: computeOneOffCosts(state).n > 0,
        /*
          This function sees ONE state and a scenario list does not fit through that keyhole — the
          dialog overrides this to `true` when the project actually has siblings, which only the
          client (and the server route) can know.
        */
        compare: false,
    };
}
//# sourceMappingURL=export-options.js.map